import debounce from "./debounce";

export default function throttle(func: any, wait: number, options?: any) {
  let leading = true;
  let trailing = true;

  if (typeof options === "object") {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    leading,
    maxWait: wait,
    trailing,
  });
}
